module.exports = __webpack_public_path__ + "static/media/kudos-message-circle.604db5c1.svg";